// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Data
import { transferSteps } from "pages/CarRentals/sections/data/carRentalData";

function HowItWorks() {
  return (
    <MKBox
      component="section"
      py={6}
      px={{ xs: 2, md: 4 }}
      sx={{ borderRadius: "lg", backgroundColor: "grey.100" }}
    >
      <Container>
        <MKTypography variant="h3" component="h1" textAlign="center" mb={1}>
          Free two-way transportation
        </MKTypography>
        <MKTypography
          variant="body1"
          color="text"
          textAlign="center"
          mb={5}
          mx="auto"
          sx={{ maxWidth: 720 }}
        >
          Rent your vehicles directly with us and we will include airport transportation &mdash;
          both ways free of charge ($350 value).
        </MKTypography>
        <Grid container spacing={4}>
          {transferSteps.map((step, index) => (
            <Grid item xs={12} sm={6} md={3} key={step.title}>
              <MKBox textAlign="center" px={2}>
                <MKBox
                  variant="gradient"
                  bgColor="info"
                  display="inline-flex"
                  alignItems="center"
                  justifyContent="center"
                  mb={2}
                  sx={{ width: 64, height: 64, borderRadius: "50%" }}
                >
                  <Icon sx={{ color: "#fff", fontSize: "2rem !important" }}>{step.icon}</Icon>
                </MKBox>
                <MKTypography variant="h6" mb={1}>
                  {index + 1}. {step.title}
                </MKTypography>
                <MKTypography variant="body2" color="text">
                  {step.text}
                </MKTypography>
              </MKBox>
            </Grid>
          ))}
        </Grid>
      </Container>
    </MKBox>
  );
}

export default HowItWorks;
